import { addNewAccount } from '@plug-core/handlers/walletActions/wallet'
import {
  ensureChainFusionAddresses,
  ensurePlugbookRecord,
} from '@plug-core/providers/WalletProvider'
import { useCurrentWallet } from '@plug-core/state'
import { setDefaultWalletName } from '@plug-core/utils/setDefaultWalletName'
import { Heading, ListGroup, ListRow, RowTile, Spinner } from '@ui'
import { ROUTES } from '@utils/routes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HiDocumentText, HiKey, HiOutlinePlusCircle } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'

const WalletImportTypePicker = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { currentWallet, setCurrentWallet } = useCurrentWallet()

  const [creatingWallet, setCreatingWallet] = useState(false)

  const createNewWallet = async () => {
    setCreatingWallet(true)

    const newAccount = await addNewAccount(currentWallet)

    await Promise.all([
      ensureChainFusionAddresses(newAccount.toString()),
      ensurePlugbookRecord(newAccount.toString()),
      setDefaultWalletName(newAccount.toString()),
    ])

    setCurrentWallet(newAccount.toString())
    setCreatingWallet(false)

    navigate(ROUTES.EDIT_ACCOUNT(newAccount.toString()), { state: { isNewAccount: true } })
  }

  const importMethods = [
    {
      type: 'new',
      icon: HiOutlinePlusCircle,
      color: 'text-danger',
      onClick: createNewWallet,
    },
    {
      type: 'privateKey',
      icon: HiDocumentText,
      color: 'text-success',
      onClick: () => navigate(ROUTES.PEM_IMPORT),
    },
    {
      type: 'stoic',
      icon: HiKey,
      color: 'text-warning',
      onClick: () => navigate(ROUTES.STOIC_IMPORT),
    },
  ]

  if (creatingWallet) {
    return (
      <div className="mt-[200px] flex flex-col items-center gap-6">
        <Spinner size={40} />
        <Heading level={4}>{t('importWallet.initializing')}</Heading>
      </div>
    )
  } else {
    return (
      <ListGroup className="mb-3">
        {importMethods.map(({ icon: Icon, color, type, onClick }) => (
          <ListRow
            key={type}
            onClick={onClick}
            leading={
              <RowTile className={color}>
                <Icon size={24} aria-hidden="true" />
              </RowTile>
            }
            primary={t(`importWallet.${type}.title`)}
            secondary={
              <span className="whitespace-normal">{t(`importWallet.${type}.description`)}</span>
            }
            chevron
          />
        ))}
      </ListGroup>
    )
  }
}

export default WalletImportTypePicker
